export function handleMenuHover() {
    const topLevelMenuItems = document.querySelectorAll('.site-navigation__list > .menu-item.menu-item-has-children');

    topLevelMenuItems.forEach((item) => {
        const link = item.querySelector('a'); 
        let isSubmenuOpen = false;

        const enterHandler = () => {
            if (window.innerWidth > 768) { 
                topLevelMenuItems.forEach((otherItem) => {
                    if (otherItem !== item) {
                        otherItem.classList.add('menu-item--inactive');
                    }
                });
                item.classList.add('menu-item--active');
                // Add a class to the body on hover
                document.body.classList.add('menu-item--hovered');
            }
        };

        const leaveHandler = () => {
            if (window.innerWidth > 768) {
                topLevelMenuItems.forEach((otherItem) => {
                    otherItem.classList.remove('menu-item--inactive');
                });
                item.classList.remove('menu-item--active');
                // Remove the class from the body when not hovering
                document.body.classList.remove('menu-item--hovered');
            }
        };

        const clickHandler = (event) => {
            if (window.innerWidth <= 768) { // Only apply on mobile
                if (!isSubmenuOpen) {
                    event.preventDefault(); // Prevent link navigation
                    item.classList.add('menu-item--open');
                    isSubmenuOpen = true;

                    // Listen for clicks outside the menu
                    document.addEventListener('click', outsideClickHandler);
                } else {
                    isSubmenuOpen = false; // Allow navigation on second click
                    item.classList.remove('menu-item--open');
                    document.removeEventListener('click', outsideClickHandler);
                }
            }
        };

        const outsideClickHandler = (event) => {
            if (!item.contains(event.target)) {
                item.classList.remove('menu-item--open');
                isSubmenuOpen = false;
                document.removeEventListener('click', outsideClickHandler);
            }
        };

        item.addEventListener('mouseenter', enterHandler);
        item.addEventListener('mouseleave', leaveHandler);
        link.addEventListener('click', clickHandler);
    });
}
